<div>
  <table class="table" *ngIf="noData == false">
    <thead class="thead-light">
      <tr>
        <th scope="col">#</th>
        <th scope="col">Action</th>
        <th scope="col" class="text-center">Time</th>
        <th scope="col" class="text-center">Remark</th>
        <th scope="col" class="text-center">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let list of historyData; let i = index">
        <th scope="row">{{ i + 1 }}</th>
        <td>{{ list.activity }}</td>
        <td class="text-center">{{ list.createdTime }}</td>
        <td class="text-center">
          <span
            *ngIf="list.remarks"
            (click)="remarksFun(list.remarks)"
            class="c-pointer"
          >
            <i class="fa fa-eye c-blue" aria-hidden="true"></i
          ></span>
          <span *ngIf="!list.remarks">-</span>
        </td>
        <td class="text-center">
          <span *ngIf="list.resolved == true">Resolved</span>
          <span *ngIf="list.resolved == false">Unresolved</span>
          <button
            *ngIf="list.resolved == false && role != 'Preincubator'"
            class="mark_btn"
            (click)="setReSolved()"
          >
            Mark as Resolved
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="text-center no-data-div" *ngIf="noData == true">
    <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
    <h6>No History Found</h6>
  </div>
  <div class="text-center mt-5">
    <button
      class="mr-2"
      mat-raised-button
      color="warn"
      (click)="cancelReason()"
    >
      Close
    </button>
  </div>
</div>
